import { render, staticRenderFns } from "./MaterialThree.vue?vue&type=template&id=b3920af2&"
import script from "./MaterialThree.vue?vue&type=script&lang=js&"
export * from "./MaterialThree.vue?vue&type=script&lang=js&"
import style0 from "./MaterialThree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports